import React from 'react';
import { Avatar } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Src = () => {
  return (
    <>
      <h4 className="mt-5">Image Avatars</h4>
      <p>
        Get image avatars by simply using the <i>src</i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <Avatar className="single-btn" src='https://wallpaperaccess.com/full/32048.jpg' />
        <Avatar className="single-btn" src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZNO3U161Gmfn4tpmvDt3j-5wQlY4CsKulAw&usqp=CAU' />
        <Avatar className="single-btn" src='https://i.pinimg.com/originals/75/a0/5d/75a05da75d10f296932d060773fe7447.jpg' />
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Avatar } from "chic-ui";'}
          <br />
          {'<Avatar src="cat1.png" />'}
          <br />
          {'<Avatar src="cat2.png" />'}
          <br />
          {'<Avatar src="cat3.png" />'}
        </code>
      </Row>
    </>
  );
};

export default Src;
